import { createContext } from "react"
import { JobForInvoicing } from "../../../domain/invoicing/invoice"
import { defaultInvoiceByJobFilters, InvoiceByJobFilters } from "../InvoiceByJob/useInvoiceByJobFilters"

export type ReadyToInvoiceSelection = undefined | {
  jobId: number
}

export type ReadyToInvoiceContextData = {
  currentSelection?: ReadyToInvoiceSelection
  clearSelection: () => void
  selectJob: (jobId: number) => void
  jobs: JobForInvoicing[]
  isLoadingJobs: boolean
  filters: InvoiceByJobFilters
  hasJobsError: boolean
  refreshJobs: () => void
  setHasPendingEdits: (pending: boolean) => void
  googleApiKey: string
}

const ReadyToInvoiceContext = createContext<ReadyToInvoiceContextData>({
  clearSelection: () => { },
  selectJob: () => { },
  jobs: [],
  isLoadingJobs: false,
  filters: defaultInvoiceByJobFilters(),
  hasJobsError: false,
  refreshJobs: () => {},
  setHasPendingEdits: () => {},
  googleApiKey: ''
})

export default ReadyToInvoiceContext
